export default __webpack_public_path__ + "static/media/containerdPull.c1316710.svg";